import React from 'react';
import {Switch} from "../../buttons/Swtich";
import BudgetValueInput from "../../elements/BudgetValueInput";
import BudgetPartialGoalsConfiguration from "../../elements/BudgetPartialGoalsConfiguration";
import { withTranslation } from 'react-i18next';


class BudgetConfigurationComponent extends React.Component {
    constructor(props) {
        super(props);
        this.handleRolloverChange = this.handleRolloverChange.bind(this);
        this.handleAmountChange = this.handleAmountChange.bind(this);
        this.handleSelectedBudgetCurrencyChange = this.handleSelectedBudgetCurrencyChange.bind(this);
        this.handleBudgetPartialGoalsChange = this.handleBudgetPartialGoalsChange.bind(this);

        this.state = {
            allocatedBudget: this.props.allocatedBudget,
            budgetCurrency: this.props.budgetCurrency,
            budgetPartialGoals: this.props.budgetPartialGoals,
            totalBudget: this.props.allocatedBudget + this.props.lastPeriodBalance
        }
    }

    handleBudgetPartialGoalsChange(budgetPartialGoals) {
        this.updateBudgetData(this.state.budgetCurrency, this.state.allocatedBudget, budgetPartialGoals);

    }

    handleRolloverChange(event) {
        this.props.onRolloverChange(event.target.checked);
    }

    handleSelectedBudgetCurrencyChange(newCurrency) {
        this.updateBudgetData(newCurrency, this.state.allocatedBudget, this.state.budgetPartialGoals);
    }

    handleAmountChange(newAmount) {
        this.updateBudgetData(this.state.budgetCurrency, newAmount, this.state.budgetPartialGoals);
    }

    updateBudgetData(currency, amount, partialGoals) {
        if (parseInt(amount, 10)) {
            const allocatedBudget = parseInt(amount, 10);
            this.setState({
                totalBudget: allocatedBudget + this.props.lastPeriodBalance,
                budgetCurrency: currency,
                allocatedBudget: amount,
                budgetPartialGoals: partialGoals
            });
            this.props.onBudgetChange(currency, allocatedBudget, partialGoals);
        } else {
            this.setState({
                totalBudget: '',
                budgetCurrency: currency,
                allocatedBudget: amount,
                budgetPartialGoals: partialGoals
            });
            this.props.onBudgetChange(null, '', null);
        }
    }

    render() {
        if (this.props.isReadOnly) {
            return this.renderReadOnlyConfiguration();
        } else {
            return this.renderEditableConfiguration()
        }
    }

    renderTitle() {
        const { t } = this.props;
        return <div key="budget" className="form-row mb-0">
            <label>{t('budget_config.allocated_budget')}</label>
        </div>
    }

    renderEditableConfiguration() {
        return [
            this.renderTitle(),
            this.renderBudgetValueInput(),
            this.renderPartialGoals(),
            this.renderRolloverConfiguration()
        ];
    }

    renderRolloverConfiguration() {
        const { t } = this.props;
        return (
            <div className="mt-3 mb-5">
                <div key="rollover" className="form-row switch-input -horizontal" style={{
                    paddingTop: "0",
                    borderBottom: "0",
                    marginBottom: "0",
                    position: "relative",
                    paddingBottom: "10px",
                    zIndex: 2, 
                    justifyContent: 'flex-start', 
                    padding: 0
                }}>
                    <Switch style={{marginLeft: "0"}} onChange={this.handleRolloverChange} checked={this.props.rollover} name="rollover"/>
                    <div style={{paddingLeft:"10px", width:"100%", position: "relative"}}>
                        <label>{t('budget_config.consider_rollover')}</label>
                    </div>
                </div>
                {this.props.rollover && (
                    <div className="radio-box-border">
                        {this.renderRolloverAdditionalInfo()}
                    </div>
                )}
            </div>
        );
    }

    renderRolloverAdditionalInfo() {
        const { t } = this.props;
        if (this.props.rollover !== true)
            return;

        return <div className="row">
            <div key="lastPeriodBalance" className="form-group col-6">
                <label>{t('budget_config.last_month_balance')}</label>
                <input name="lastPeriodBalance" readOnly={true} value={this.props.lastPeriodBalance}
                       className="form-control" type="text"/>
            </div>
            <div key="totalBalance" className="form-group col-6">
                <label>{t('budget_config.total_resulting_budget')}</label>
                <input name="totalBalance" readOnly={true} value={this.state.totalBudget}
                       className="form-control" type="text"/>
            </div>
        </div>;
    }

    renderBudgetValueInput() {
        return <div key="budget" className="form-row">
            <div className="col-md-6 pl-0">
                <BudgetValueInput budgetCurrency={this.state.budgetCurrency}
                                  onCurrencyChange={this.handleSelectedBudgetCurrencyChange}
                                  onAmountChange={this.handleAmountChange}
                                  budgetAmount={this.props.allocatedBudget}
                                  canEditCurrency={this.props.canEditCurrency}
                />
            </div>
        </div>;
    }

    renderPartialGoals() {
        return <div key="budget-partial-goals" className="form-row">
            <div className="col-md-12 pl-0">
                <BudgetPartialGoalsConfiguration
                    enabled={(this.state.budgetPartialGoals !== null && this.state.budgetPartialGoals !== undefined && this.state.budgetPartialGoals.length > 0)}
                    budgetPeriodType={this.props.periodType}
                    budgetFromDate={this.props.periodFirstDate}
                    budgetToDate={this.props.periodLastDate}
                    budgetPartialGoals={this.state.budgetPartialGoals}
                    onChange={this.handleBudgetPartialGoalsChange}
                    budgetTotalAmount={this.props.allocatedBudget}
                />
            </div>
        </div>;
    }

    renderReadOnlyConfiguration() {
        const { t } = this.props;
        return (
            <div key="budget" className="form-row">
                <label>{t('budget_config.allocated_budget')}</label>
                {this.renderAllocatedBudgetField()}
                <p className="field-footnote">{this.props.budgetFootnoteText}</p>
            </div>
        )
    }

    getBudgetValueReadOnlyText() {
        let formattedValue = this.props.allocatedBudget;
        if (formattedValue !== null) {
            formattedValue = Number(formattedValue).toLocaleString('en-US');
        }

        if(this.props.canEditCurrency) {
            return this.props.budgetCurrency + "$ " + formattedValue;
        }
        return "$ " + formattedValue;
    }

    renderAllocatedBudgetField() {
        return <input name="budget"
                      readOnly={true}
                      className="form-control"
                      onChange={this.handleBudgetChange}
                      value={this.getBudgetValueReadOnlyText()}
                      type="text"/>
    }
}

export const BudgetConfiguration = withTranslation()(BudgetConfigurationComponent);
